export default __webpack_public_path__ + "static/media/an7.39d3bbac.jpg";